export default {
    mounted(el, binding) {
        //Event
        const onMove = binding.value;
        const element = el;
        //Listener
        window.addEventListener('scroll', (e) => { onMove(element, e); });
        window.addEventListener('resize', (e) => { onMove(element, e); });
        //Invoke
        onMove(element, {});
    },
    unmounted(el, binding) {
        //Event
        const onMove = binding.value;
        const element = el;
        //Listener
        window.removeEventListener('scroll', (e) => { onMove(element, e); });
        window.removeEventListener('resize', (e) => { onMove(element, e); });
    }
};
